import { required, email } from 'vuelidate/lib/validators'

export default {
  invite: {
    document: {
      required
    },
    name: {
      required
    },
    state: {
      required
    },
    email: {
      required,
      email
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/form/components/invite/resources/validations.js